import { t as tr } from '@hana/i18n';
import './MatchQueue.i18n';
import { useState } from 'react';
import { IconChecks, IconLink, IconPlus } from '@tabler/icons-react';
import { Button, useToast } from '@hana/ui';
import { MATCH_LINES, highConfidence, selectedLine, type MatchConf } from './costingMatch';
import { f1 } from './view';
import { useT } from '@hana/i18n';
import s from './matchQueue.module.css';
import './finance.i18n';

// Mint-Cost › tab Hàng chờ ghép: trái = dòng HĐ chưa ghép, phải = dòng dự kiến gợi ý cho dòng đang chọn. Chỉ đọc; nút ghi báo toast.

const NO_DONE: ReadonlySet<number> = new Set();
const CONF_TONE: Record<MatchConf, string | undefined> = { Cao: s.cOk, Vừa: s.cWarn, Thấp: s.cGray };

export function MatchQueue() {
  const toast = useToast();
  const tx = useT();
  const [sel, setSel] = useState<number | null>(null);
  const noWrite = () => toast({ msg: 'Chưa mở ghi ở bản này' });
  const cur = selectedLine(MATCH_LINES, NO_DONE, sel);
  const hi = highConfidence(MATCH_LINES, NO_DONE);
  const cands = cur === null ? [] : MATCH_LINES[cur]![5];

  return (
    <div className={s.grid}>
      <section className={s.card} aria-label="Dòng hoá đơn chưa ghép">
        <div className={s.head}>
          <h2>{tx('fn.mqUn')}</h2>
          <span className={s.meta}>
            {MATCH_LINES.length} dòng
            {hi.length > 1 && (
              <Button onClick={noWrite} icon={<IconChecks size={16} aria-hidden="true" />}>
                Nhận {hi.length} gợi ý tin cậy cao
              </Button>
            )}
          </span>
        </div>
        {MATCH_LINES.map((l, i) => (
          <button key={`${l[1]}-${l[0]}`} type="button" className={s.line} aria-pressed={cur === i} onClick={() => setSel(i)}>
            <div className={s.lt}>
              <div className={s.name}>{l[0]}</div>
              <div className={s.sub}>
                {l[1]} · {l[2]} · {l[3]}
              </div>
            </div>
            <b>{f1(l[4])}</b>
          </button>
        ))}
        <div className={s.note}>{tx('fn.mqNote')}</div>
      </section>
      <section className={s.card} aria-label="Dòng chi phí dự kiến gợi ý">
        <div className={s.head}>
          <h2>{tx('fn.mqSug')}</h2>
          <span className={s.meta}>cho {cur === null ? '—' : MATCH_LINES[cur]![0]}</span>
        </div>
        {cands.map(([job, svc, code, exp, why, conf]) => (
          <div key={`${job}-${code}`} className={s.cand}>
            <div className={s.lt}>
              <div className={s.name}>
                {job} · {svc}
              </div>
              <div className={s.sub}>
                {code} · dự kiến {exp} · {why}
              </div>
            </div>
            <span className={`${s.conf} ${CONF_TONE[conf] ?? ''}`}>Tin cậy {conf.toLowerCase()}</span>
            <Button variant="primary" icon={<IconLink size={16} aria-hidden="true" />} onClick={noWrite}>
              {tr('mque.1')}
            </Button>
          </div>
        ))}
        {cur !== null && cands.length === 0 && <div className={s.none}>{tx('fn.mqNone')}</div>}
        <div className={s.acts}>
          <Button onClick={noWrite} icon={<IconPlus size={16} aria-hidden="true" />}>
            {tr('mque.2')}
          </Button>
          <button type="button" className={s.ask} onClick={() => toast({ msg: 'Hỏi Hana chưa mở ở bản này' })}>
            {tr('mque.3')}
          </button>
        </div>
      </section>
    </div>
  );
}
